import { Button } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React from 'react'
import { FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { PaymentRequestModalWrapper } from './PaymentRequestModalWrapper'

export const PaymentRequestButton = () => {
  const [showPaymentRequestModal, setShowPaymentRequestModal] = React.useState(
    false
  )

  const openPaymentRequestModal = () => {
    setShowPaymentRequestModal(true)
  }

  const isFeatureEnabled = getFeatureFromCache(
    FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS
  )

  if (!isFeatureEnabled) {
    return null
  }

  return (
    <>
      <div className="vd-mt4">
        <Button
          jumbo
          className="btn--payment-request"
          variant="supplementary"
          onClick={openPaymentRequestModal}
        >
          <T _str="Request payment" _context="Payment request button label"></T>
        </Button>
      </div>
      <PaymentRequestModalWrapper
        open={showPaymentRequestModal}
        setOpen={() => setShowPaymentRequestModal(false)}
      />
    </>
  )
}
